"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("./core");
// TODO: Access to sentry
class ErrorBoundary extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        // update state so that the next rendering shows the degraded UI
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        if (!this.props.logError) {
            return;
        }
        // TODO: how does the third-party iframe widget work
        core_1.Player.doTrigger(core_1.Events.app_error_logger, {
            error,
            metaData: {
                errorInfo,
                props: this.props,
            },
        });
    }
    render() {
        if (this.state.hasError) {
            // TODO: widget i18n solution, should not introduce strings in the apitable/core
            return react_1.default.createElement("h1", null, "An unknown error has occurred, please refresh and retry"); //Something went wrong.
        }
        // @ts-ignore
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
